import * as React from "react";

import * as Api from "ApiContracts/control/api/api";

export const OrgContext: React.Context<Api.ListOrgs_Item | undefined> = React.createContext<
  Api.ListOrgs_Item | undefined
>(undefined);
